import { MUTATIONS, STATE } from "./names";

export default {
    [MUTATIONS.SET_FULL_PAGE_LOADING](state, { visible, text }) {
        state[STATE.FULL_PAGE_LOADING_VISIBLE] = visible;
        state[STATE.FULL_PAGE_LOADING_TEXT] = text;
    }
}
